import { FallbackError } from "@core/domain/errors/fallback.error";
import { ValidationError } from "@core/domain/errors/validation.error";
import { Pagination } from "@core/domain/models/pagination";
import { Either } from "@core/domain/types/either";
import { ProjectKanbanBlockDataSource } from "@project/data/datasource/project-kanban-block.datasource";
import { ProjectKanbanBlock } from "@project/domain/models/project-kanban-block.model";
import { inject, injectable } from "inversify";

@injectable()
export class ProjectKanbanBlockRepository {
    constructor(
        @inject(ProjectKanbanBlockDataSource)
        private readonly dataSource: ProjectKanbanBlockDataSource,
    ) {}

    async getAllBy(filters: {
        project: number;
    }): Promise<Either<FallbackError, ProjectKanbanBlock[]>> {
        const pagination: Pagination = Pagination.NoPagination();
        return this.dataSource.fetchBy(pagination, filters);
    }

    create(body: {
        project: number;
        name: string;
        phase?: string;
    }): Promise<Either<ValidationError | FallbackError, ProjectKanbanBlock>> {
        return this.dataSource.create(body);
    }

    update(
        id: number,
        body: {
            name?: string;
            phase?: string;
            is_active?: boolean;
        },
    ): Promise<Either<ValidationError | FallbackError, ProjectKanbanBlock>> {
        return this.dataSource.update(id, body);
    }

    delete(id: number): Promise<Either<FallbackError, true>> {
        return this.dataSource.delete(id);
    }

    reorder(payload: {
        project: number;
        ids: number[];
    }): Promise<Either<ValidationError | FallbackError, ProjectKanbanBlock[]>> {
        return this.dataSource.reorder(payload);
    }
}
